import { render, staticRenderFns } from "./AllSupport.vue?vue&type=template&id=831269c6&"
import script from "./AllSupport.vue?vue&type=script&lang=js&"
export * from "./AllSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports